import { movies } from "@/mocks/movies";
import { tvShows } from "@/mocks/tvshows";
import type { Media } from "@/types/media";

export const allMedia: Media[] = [...movies, ...tvShows];

export function getMediaById(id: string | undefined): Media | undefined {
  if (!id) return undefined;
  return allMedia.find((item) => item.id === id);
}

export function getRelated(current: Media, count = 4): Media[] {
  return allMedia
    .filter((item) => item.id !== current.id && item.type === current.type)
    .map((item) => ({
      item,
      score: item.genres.filter((g) => current.genres.includes(g)).length,
    }))
    .sort((a, b) => b.score - a.score || b.item.rating - a.item.rating)
    .slice(0, count)
    .map((entry) => entry.item);
}

export function filterMedia(params: {
  type: Media["type"];
  genre?: string;
  region?: string;
  year?: string;
  sort?: string;
  episodes?: string;
}): Media[] {
  const { type, genre, region, year, sort, episodes } = params;
  let list = allMedia.filter((item) => item.type === type);

  if (genre && genre !== "全部") list = list.filter((item) => item.genres.includes(genre));
  if (region && region !== "全部") list = list.filter((item) => item.region === region);
  if (year && year !== "全部") list = list.filter((item) => String(item.year) === year);

  if (type === "tv" && episodes && episodes !== "全部") {
    list = list.filter((item) => {
      const count = item.episodes ?? 0;
      if (episodes === "20集以内") return count <= 20;
      if (episodes === "20-50集") return count > 20 && count <= 50;
      if (episodes === "50集以上") return count > 50;
      return true;
    });
  }

  if (sort === "评分最高") {
    list = [...list].sort((a, b) => b.rating - a.rating);
  } else if (sort === "播放最多") {
    list = [...list].sort((a, b) => b.heat - a.heat);
  } else {
    list = [...list].sort((a, b) => b.year - a.year);
  }

  return list;
}

export function formatHeat(heat: number): string {
  if (heat >= 10000) return `${(heat / 10000).toFixed(1)}万`;
  return `${heat}`;
}